import log from 'loglevel';

/**
 * 获取文件后缀名(带原点)
 * 示例：
 *  extname('abc.TXT') => '.txt'
 *  extname('abc.') => '.'
 *  extname('abc') => ''
 * @param {String} filename 文件名
 * @returns 存在返回小写后缀名, 否则返回''
 */
export function extname(filename) {
  if (typeof filename === 'string') {
    const i = filename.lastIndexOf('.');
    if (i > -1) {
      return filename.substring(i).toLocaleLowerCase();
    }
  }
  return '';
}

/**
 * 加载base
 */
export function loadMsgScript() {
  return new Promise((resolve, reject) => {
    if (document.getElementById('VhallBaseSDK')) {
      resolve(true);
      return;
    }
    let scriptEl = document.createElement('script');
    scriptEl.setAttribute('type', 'text/javascript');
    scriptEl.setAttribute('id', 'VhallBaseSDK');
    scriptEl.onload = () => resolve(true);
    scriptEl.onerror = err => reject(new Error(err));
    scriptEl.setAttribute('src', process.env.BASE_MESSAGE_URL + '?t=' + Date.now());
    document.head.appendChild(scriptEl);
  });
}

// eslint-disable-next-line no-extend-native
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 24小时制
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  return fmt;
};

// 防抖
export function debounce(fn, delay) {
  var timer = null;
  return function () {
    var _this = this;
    var _args = arguments;
    // 清除上一个timer
    clearTimeout(timer);
    // 当最后回调时，经过delay毫秒后执行事件处理程序
    timer = setTimeout(function () {
      fn.apply(_this, _args);
    }, delay);
  };
}

// 节流
export function throttle(fn, delay) {
  var last = 0;
  return function () {
    var cur = +new Date();
    if (cur - last > delay) {
      fn.apply();
      last = cur;
    }
  };
}

export function isMobile() {
  return !!navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}

/**
 * 判断浏览器是否支持flash
 */
export function hasUsableSWF() {
  let swf = null;
  if (typeof window.ActiveXObject !== 'undefined') {
    try {
      swf = new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash');
    } catch (e) {
      return !!swf;
    }
  } else {
    swf = navigator.plugins['Shockwave Flash'];
  }
  return !!swf;
}

export function judgeX5() {
  let ua = navigator.userAgent.toLowerCase();
  let isAndroid = ua.match(/android|adr/i);
  let isTencent = ua.match(/mqqbrowser|qzone|qqbrowser|qq|micromessenger/i);

  return isAndroid && isTencent;
}

export function b64EncodeUnicode(str) {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16));
    })
  );
}

export function b64DecodeUnicode(str) {
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );
}

export function guid() {
  return 'xxxxxxxx-xxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0;
    var v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function clearAllNode(parentNode) {
  while (parentNode.firstChild) {
    parentNode.removeChild(parentNode.firstChild);
  }
}

export function loadStyles(url) {
  var link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = url;
  document.getElementsByTagName('head')[0].appendChild(link);
}

export function lockOrientationUniversal(mode) {
  (screen.orientation &&
    screen.orientation.lock(mode).then(
      () => {},
      err => log.error('lockOrientationUniversal error:' + err)
    )) ||
    (screen.mozLockOrientation && screen.mozLockOrientation(mode)) ||
    (screen.msLockOrientation && screen.msLockOrientation(mode));
}

export const nameMap = {
  dragStart: isMobile() ? 'touchstart' : 'mousedown',
  dragMove: isMobile() ? 'touchmove' : 'mousemove',
  dragEnd: isMobile() ? 'touchend' : 'mouseup'
};

/**
 * 对象合并
 * 后面的会覆盖前面的对象属性，会递归遍历
 * @param {Object} target 目标对象
 * @param {[sources]} sources 来源对象，需要被合并的数据源
 * @returns 返回合并后的对象
 */
export function deepAssign(target, ...sources) {
  if (isPlainObject(target) && Array.isArray(sources)) {
    sources.forEach(obj => {
      for (let key in obj) {
        if (isPlainObject(obj[key])) {
          if (!target[key]) {
            target[key] = {};
          }
          deepAssign(target[key], obj[key]);
        } else {
          target[key] = obj[key];
        }
      }
    });
  }
  return target;
}

/**
 * 判断指定参数是否是一个纯粹的对象
 * @param {Any} obj
 * @returns 是返回true, 否则返回false
 */
export function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

/**
 * url拼接
 * 示例：
 *  urljoin('https://test.com','/demo','index.html') => 'https://abc.com/demo/index.html'
 *  urljoin('//test.com','assets','main.css') => '//test.com/assets/main.css'
 * @param  {...string} paths 带拼接的路径数组
 * @returns
 */
export function urljoin(...paths) {
  if (Array.isArray(paths) && paths.length) {
    return paths.reduce((url, currentValue, idx) => {
      if (typeof currentValue === 'string') {
        // 去除两边空格，并去除最后面的斜杠(/)
        currentValue = currentValue.trim().replace(/\/*$/gi, '');
        if (idx === 0) {
          url = currentValue;
        } else {
          // 去除最前面的斜杠(/)
          currentValue = currentValue.replace(/^\/*/gi, '');
          if (currentValue) {
            url = `${url}/${currentValue}`;
          }
        }
      }
      return url;
    }, '');
  }
  return '';
}

/**
 * 浏览器兼容性探测
 * @param {*} opt
 * @param {*} success
 * @param {*} failure
 */
export function probe(opt = {}, success, failure) {
  const info = {};
  try {
    const video = document.createElement('video');
    // 浏览器是否支持video元素
    info['HTMLVideoElement'] = !!(video && video.canPlayType);
    // 是否支持h.264解码
    info['H264'] = !!(video && video.canPlayType && video.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"'));
    // 是否支持vp8解码
    info['WebM_VP8'] = !!(video && video.canPlayType && video.canPlayType('video/webm; codecs="vp8.0, vorbis"'));

    const mse = window['MediaSource'] || window['WebKitMediaSource'];
    // 是否支持MSE
    info['MediaSourceExtensions'] = !!mse;
    const checkMSECompatibility = function (mimeType) {
      if (mse && !mse.isTypeSupported) {
        // When async type detection is required, fall back to canPlayType.
        return video.canPlayType(mimeType);
      } else {
        return mse && mse.isTypeSupported(mimeType);
      }
    };
    // MSE是否支持h264解码
    info['MSE_H264'] = checkMSECompatibility('video/mp4; codecs="avc1.4d401e"');
    // MSE是否支持vp9解码
    info['MSE_WebM_VP9'] = checkMSECompatibility('video/webm; codecs="vp9"');
    // 是否支持websocket链接
    info['WebSocket'] = !!window['WebSocket'];
    // 是否为x5内核
    info['x5'] = !!judgeX5();
    // 是否支持webRTC
    const webRTC = window['RTCPeerConnection'] || window['webkitRTCPeerConnection'];
    info['WebRTC'] = !!webRTC && info['H264'];
    success(info);
  } catch (e) {
    failure(e);
  }
}

/**
 * @description 弹幕设置 校验方法
 * @param {danmakuSetting} danmakuSetting
 * @returns {Object} error { code: ,msg: }
 */
export function checkDanmakuSetting(danmakuSetting) {
  if (typeof danmakuSetting !== 'object') {
    throw new Error({
      code: '611001',
      message: '弹幕设置参数无效'
    });
  }
  if (danmakuSetting.style.fontSize && (~danmakuSetting.style.fontSize > 50 || ~danmakuSetting.style.fontSize < 12)) {
    throw new Error({
      code: '611001',
      message: '弹幕设置,字体大小参数无效'
    });
  }

  if ((danmakuSetting.style.opacity && ~danmakuSetting.style.opacity > 100) || ~danmakuSetting.style.opacity < 0) {
    throw new Error({
      code: '611001',
      message: '弹幕设置,字体透明度参数无效'
    });
  }

  if ((danmakuSetting.style.opacity && ~danmakuSetting.style.opacity > 100) || ~danmakuSetting.style.opacity < 0) {
    throw new Error({
      code: '611001',
      message: '弹幕设置,字体透明度参数无效'
    });
  }
}

/**
 *@description 检查是否支持画中画
 */
export function isSupportPictureInPicture() {
  return !!document.pictureInPictureEnabled;
}

/**
 * 预加载雪碧图图片文件
 * @param {*} url
 * @param {*} onload
 * @param {*} onerror
 * @returns
 */
export function preloadImg(url, onload = () => {}, onerror = () => {}) {
  if (!url) {
    return;
  }
  let img = new window.Image();
  img.onload = e => {
    img = null;
    onload && onload(e);
  };
  img.onerror = e => {
    img = null;
    onerror && onerror(e);
  };
  img.src = url;
}

/**
 * 当前时间格式转换
 * @param {*} result
 * @returns
 */
export function secondFormat(result) {
  var hour = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  var minute =
    Math.floor((result / 60) % 60) < 10 ? '0' + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60);
  var second = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60);
  return (hour === '00' ? [minute, second] : [hour, minute, second]).join(':');
}
